require('./openYoungCardExpensesGraph.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { Link } = require('react-router-dom');
const classNames = require('classnames');
const moment = require('moment');

// @constants
const { getCategoryIcon } = require('constants/categories');
const { EURO_TEXT, DATE_FORMAT_FULL_MONTH, BY_EXPENSES } = require('constants/index');
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');

// @components
const OpenYoungCardExpensesBars = require('./openYoungCardExpensesBars/openYoungCardExpensesBars');
const OpenYoungCardExpensesFilter = require('./openYoungCardExpensesFilter/openYoungCardExpensesFilter');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const { getFormattedString, formatCurrency } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');

class OpenYoungCardExpensesGraph extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterSettingsOpen: false
        }
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    buildHeaderContent(totalCurrentPeriod, totalPreviousPeriod) {
        const { immFilters } = this.props;
        const currencySymbol = formatCurrency(EURO_TEXT);
        let showCompare = immFilters.getIn(['date','isActive']);
        let currentMonth = moment().locale(DATE_PICKER_CUSTOM_LOCALE).format(DATE_FORMAT_FULL_MONTH);
        let previousMonth;
        const formmatedTotalCurrentPeriod = getFormattedString({
            amount: totalCurrentPeriod,
            currency: currencySymbol
        });
        const formattedTotalPreviousPeriod = getFormattedString({
            amount: totalPreviousPeriod,
            currency: currencySymbol
        });

        if(showCompare) {
            previousMonth = moment(immFilters.getIn(['date','selectedMonth'])).locale(DATE_PICKER_CUSTOM_LOCALE).format(DATE_FORMAT_FULL_MONTH);
        }
        const prevMonthTotalPeriodContent = showCompare && (
            <div className="openyoung-card-expenses-graph__total-privious-period">
                <span className="openyoung-card-expenses-graph__bullet openyoung-card-expenses-graph__bullet--previous">{previousMonth && toFirstUppercase(previousMonth)}</span>
                <span className="openyoung-card-expenses-graph__bullet-amount">
                    {formattedTotalPreviousPeriod}
                </span>
            </div>
        );
        const currentMonthPrefix = !showCompare && formatText('openYoungCardExpensesGraph-currentMonthPrefix');

        const totalPeriodClassNames = classNames('openyoung-card-expenses-graph__total-period',{
            'openyoung-card-expenses-graph__total-period--comparison': showCompare
        });

        return (
            <div className="openyoung-card-expenses-graph__header-content">
                <div className="openyoung-card-expenses-graph__filters">
                    <OKButton modifier="task" onClick={this.handleToggleFilters}>
                        <i className="icon icon-filtrar openyoung-card-expenses-graph__filter-settings-icon" />
                    </OKButton>
                </div>
                <div className={totalPeriodClassNames}>
                    <div className="openyoung-card-expenses-graph__total-current-period">
                        <span className="openyoung-card-expenses-graph__bullet">{currentMonthPrefix}{currentMonth && toFirstUppercase(currentMonth)}</span>
                        <span className="openyoung-card-expenses-graph__bullet-amount">
                            {formmatedTotalCurrentPeriod}
                        </span>
                    </div>
                    {prevMonthTotalPeriodContent}
                </div>
            </div>
        );
    }

    render() {
        const { immExpenses, immFilters, handleSetFilter, cardId } = this.props;
        const currencySymbol = formatCurrency(EURO_TEXT);
        const categoriesOrder = immExpenses.get('categoriesOrder');
        let expensesListRendered;
        let showCompare = immFilters.getIn(['date','isActive']);
        let maximumCurrentPeriod = 0;
        let totalCurrentPeriod = 0;
        let totalPreviousPeriod = 0;
        let isValidExpensePresent = false;
        let content;

        categoriesOrder.forEach(category => {
            const currentPeriod = immExpenses.getIn(['currentPeriod',category,'monto']) || 0;
            const previousPeriod = immExpenses.getIn(['previousPeriod',category,'monto']) || 0;

            totalCurrentPeriod += currentPeriod;
            totalPreviousPeriod += previousPeriod;

            if (showCompare) {
                maximumCurrentPeriod = Math.max(
                    maximumCurrentPeriod,
                    currentPeriod,
                    previousPeriod
                );
            } else {
                maximumCurrentPeriod = Math.max(
                    maximumCurrentPeriod,
                    currentPeriod
                );
            }
        });

        expensesListRendered = categoriesOrder.map(category => {
            const currentPeriod = immExpenses.getIn(['currentPeriod',category,'monto']) || 0;
            const previousPeriod = immExpenses.getIn(['previousPeriod',category,'monto']) || 0;

            if(currentPeriod || previousPeriod) {
                isValidExpensePresent = true;

                const iconClasses = classNames(
                    'openyoung-card-expenses-graph__expense-icon',
                    getCategoryIcon(category)
                );
                const iconElement = (
                    <div className="openyoung-card-expenses-graph__icon-column">
                        <i
                            className={iconClasses}
                            onClick={() => {}}
                        />
                    </div>
                );
                const compareValueComponent = showCompare && (
                    <span className="openyoung-card-expenses-graph__previous-amount">
                        {formatAmount(previousPeriod)} {currencySymbol}
                    </span>
                );

                return (
                    <Link key={category} to={`/myprofile/cards/${cardId}/budgets/expenses-by-category/${category}/${BY_EXPENSES}`} className="openyoung-card-expenses-graph__link-box">
                        <li>
                            {iconElement}
                            <div className="openyoung-card-expenses-graph__bars-column">
                                <FormattedText
                                    value={`categories-${category}`}
                                    className={"openyoung-card-expenses-graph__category-text"}
                                />
                                <OpenYoungCardExpensesBars
                                    maxExpenses={maximumCurrentPeriod}
                                    currentPeriod={currentPeriod}
                                    comparePeriod={previousPeriod}
                                />
                            </div>
                            <div className="openyoung-card-expenses-graph__amount-column">
                                <span>
                                    {formatAmount(currentPeriod)} {currencySymbol}
                                </span>
                                {compareValueComponent}
                            </div>
                        </li>
                    </Link>
                );
            }
        });

        const headerContent = this.buildHeaderContent(totalCurrentPeriod, totalPreviousPeriod);
        if(!isValidExpensePresent) {
            content = (
                <EmptyState
                    primaryText={formatText('openYoungCardExpenses-noExpenses')}
                    iconType="search-banking" />
            );
        } else {
            content = (
                <ul className="openyoung-card-expenses-graph__expenses-list">
                    {expensesListRendered}
                </ul>
            );
        }

        return (
            <div className="row openyoung-card-expenses-graph">
                <div className="col-xs-12">
                    {headerContent}
                    {content}
                    <OpenYoungCardExpensesFilter
                        immFilters={immFilters}
                        isOpen={this.state.filterSettingsOpen}
                        onCloseClick={this.handleToggleFilters}
                        onFilterSubmitClick={handleSetFilter}
                    />
                </div>
            </div>
        );
    }
}

OpenYoungCardExpensesGraph.propTypes = {
    cardId: PropTypes.string.isRequired,
    handleSetFilter: PropTypes.func.isRequired,
    immExpenses: PropTypes.object.isRequired,
    immFilters: PropTypes.object.isRequired
};

module.exports = OpenYoungCardExpensesGraph;
